import axios from 'axios';
import getEnvVariable from '../utils/env';

const googleApiKey = getEnvVariable('REACT_APP_GOOGLE_API_KEY');

function request({ method, url, data, axiosOptions, responseType = 'json' }) {
  let options = {
    responseType,
    url,
    method,
    data,
    ...axiosOptions
  };
  return axios(options)
    .then((response) => response.data)
    .catch((err) => {
      console.error('Error on the url', url);
      console.error(err);
      return false;
    });
}

export function translateTexts(text, target) {
  return request({
    method: 'POST',
    url: `https://translation.googleapis.com/language/translate/v2?key=${googleApiKey}`,
    data: {
      q: text,
      target
    }
  });
}
